import { render, staticRenderFns } from "./project_count.vue?vue&type=template&id=2ad502b4&scoped=true"
import script from "./project_count.vue?vue&type=script&lang=js"
export * from "./project_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad502b4",
  null
  
)

export default component.exports